import type { ColumnAlignment } from "../../../canvas/state/types";

export const texts: Record<ColumnAlignment, string> = {
  left: "Align Left",
  center: "Align Center",
  right: "Align Right",
};
